import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

import { RegistroCandidatoRequestInterface } from '../interfaces/candidato/registro-candidato-request.interface';

interface Usuario {
  id: number;
  nombre: string;
  edad: number;
}

@Injectable({
  providedIn: 'root'
})
export class IndexedDbService {
  private dbName = 'ManpowerGroupDB';
  private storeName = 'registro';
  private db!: IDBPDatabase;

  constructor() {
    this.initDB();
  }

  async initDB() {
    this.db = await openDB(this.dbName, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('registro')) {
          db.createObjectStore('registro', { keyPath: 'id' });
        }
      }
    });
  }

  async guardarUsuario(usuario: RegistroCandidatoRequestInterface) {
    if (!usuario.id) {
      console.error('El registro debe tener un UUID antes de guardarlo');
      return;
    }
    await this.db.put(this.storeName, usuario);
    console.log('Registro guardado:', usuario);
  }

  async obtenerUsuario(id: string): Promise<RegistroCandidatoRequestInterface | undefined> {
    return await this.db.get(this.storeName, id);
  }

  async eliminarUsuario(id: string) {
    await this.db.delete(this.storeName, id);
    console.log(`Registro con ID ${id} eliminado`);
  }

  async obtenerTodosUsuarios(): Promise<RegistroCandidatoRequestInterface[]> {
    return await this.db.getAll(this.storeName);
  }
}
